export const ITEMS_PER_PAGE = 10;

export const INITIAL_LOT_TICKET_STATE = {
  uuid_lot: '',
  uuid_district: '',
  uuid_country: '',
  uuid_province: '',
  uuid_department: '',
  uuid_marital_status: '',
  uuid_nationality: '',
  full_name: '',
  ticket_number: '',
  dni: '',
  address: '',
  email: '',
  phone_number: '',
  postal_code: '',
  birth_date: '',
  gender: '',
  details: '',
};
